import React from 'react'
import { styled } from '@stitches/react'

interface ISelectOption {
    label: string
    value: string | number
}

interface SelectInputProps {
    label: string
    emptyOptionLabel?: string
    options: Array<ISelectOption>
    value: string

    onValueChange?(value: string): void
}

const Container = styled('div', {
    display: 'flex',
    flexDirection: 'column',
})

const Label = styled('label', {
    display: 'flex',
    width: 'fit-content',
    zIndex: 2,
    padding: '0 4px',
    marginLeft: '12px',
    marginBottom: '-8px',
    backgroundColor: '$white',
    fontSize: '12px',
})

const Select = styled('select', {
    padding: '1em',
    border: '2px solid $mediumGray',
    borderRadius: '$2',
    lineHeight: 1,
    backgroundColor: 'white',
    color: '$dark',
    '&:focus': {
        outline: 'unset',
        borderColor: '$primary',
        '~ label': {
            color: '$primary',
        },
    },
})

const HtmlSelectInput = ({
    label,
    emptyOptionLabel,
    options,
    value,
    onValueChange,
    ...props
}: SelectInputProps) => {
    return (
        <Container>
            <Label id={'label'} htmlFor={'select-input'}>
                {label}
            </Label>
            <Select
                id={'select-input'}
                {...props}
                onChange={(event) => {
                    onValueChange && onValueChange(event.target.value)
                }}
            >
                <option key={'empty'} value={'empty'}>
                    {emptyOptionLabel ?? '-'}
                </option>
                {options.map((option: ISelectOption) => {
                    return (
                        <option key={option.value} value={option.value}>
                            {option.label}
                        </option>
                    )
                })}
            </Select>
        </Container>
    )
}

export default HtmlSelectInput
